import { Component, computed, effect, inject, signal } from '@angular/core';
import { RestaurantConfigService } from '../../services/restaurant-config.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent {
  private readonly restaurantConfig = inject(RestaurantConfigService);

  readonly menuDto = this.restaurantConfig.menu;

  activeCategory = signal<number | null>(null);

  readonly categories = computed(() => {
    const dto = this.menuDto()?.categories;
    if (!dto?.length) {
      return [] as {
        id: number;
        label: string;
        items: {
          id: number;
          name: string;
          description: string;
          price: string;
          vegetarian: boolean;
          glutenFree: boolean;
        }[];
      }[];
    }
    return dto.map((cat) => ({
      id: cat.id,
      label: cat.name,
      items: cat.items
        .filter((i) => i.available)
        .map((i) => ({
          id: i.id,
          name: i.name,
          description: i.description ?? '',
          price: this.restaurantConfig.formatPrice(i.price),
          vegetarian: i.vegetarian ?? false,
          glutenFree: i.glutenFree ?? false,
        })),
    }));
  });

  readonly activeItems = computed(() => {
    const id = this.activeCategory();
    const cats = this.categories();
    if (id == null) {
      return [];
    }
    return cats.find((c) => c.id === id)?.items ?? [];
  });

  constructor() {
    effect(() => {
      const cats = this.categories();
      if (cats.length && this.activeCategory() === null) {
        this.activeCategory.set(cats[0].id);
      }
    });
  }

  setCategory(id: number) {
    this.activeCategory.set(id);
  }
}
